import * as UI from '@brewlogix/blx-ui'

import { Ingredient } from 'src/types/schema/graphql'
import Label from '../Label'
import React from 'react'
import { snakeToPascal } from 'src/util/helpers'

type IYeast = {
    yeasts: Ingredient[]
}

const Yeasts: React.FC<IYeast> = ({ yeasts }: IYeast) => {
    return (
        <div className='flex flex-col gap-2'>
            <Label labelText='Yeasts' />
            <div className='flex flex-wrap gap-1'>
                {yeasts?.map((item) => (
                    <UI.Pill
                        key={item?.title}
                        label={snakeToPascal(item?.title)}
                        customClasses='bg-gray-100 text-base py-1 px-3 text-gray-500'
                    />
                ))}
            </div>
        </div>
    )
}

export default Yeasts
